import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

export default function ScoreTypeSelect(args: any) {
  const [age, setAge] = React.useState('');
    const [func] = React.useState(args.onSelect);
  const handleChange = async (event: SelectChangeEvent) => {
    const value = event.target.value as string
    setAge(value);
    await func.onSelect(value)
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Filter by</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={age}
          label="Score type"
          onChange={handleChange}
        >
          <MenuItem value={0}>Pending</MenuItem>
          <MenuItem value={1}>Win</MenuItem>
          <MenuItem value={2}>Loss</MenuItem>
          <MenuItem value={3}>Push</MenuItem>
          <MenuItem value={4}>Void</MenuItem>
          <MenuItem value={5}>Double Push</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}